import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// Line-by-line masked reveal. Pass an array of strings (lines).
export function RevealLines({ lines, className = "", delay = 0, stagger = 0.12, as = "div" }) {
  const Tag = motion[as] || motion.div;
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="line-mask">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, ease: EASE, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

// Scroll-triggered line reveal (whileInView).
export function RevealLinesOnView({ lines, className = "", stagger = 0.1 }) {
  return (
    <div className={className}>
      {lines.map((line, i) => (
        <span key={i} className="line-mask">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            whileInView={{ y: "0%" }}
            viewport={{ once: true, margin: "-10% 0px" }}
            transition={{ duration: 0.85, ease: EASE, delay: i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </div>
  );
}

// Generic fade-up on scroll.
export function FadeUp({ children, className = "", delay = 0, y = 40 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-8% 0px" }}
      transition={{ duration: 0.8, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

export { EASE };
